import script from "./DepartmentConceptsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentConceptsTab.vue?vue&type=script&setup=true&lang=js"

import "./DepartmentConceptsTab.vue?vue&type=style&index=0&id=446956ce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-446956ce"]])

export default __exports__